import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { TJobOverviewPageRoutes } from './Types';
import { useSafeLocationState } from './useSafeLocationState';

export enum TAB {
  JOB_DETAILS = 'job-details',
  CANDIDATES = 'candidates',
  WORKING_INTERVIEWS = 'onsite-interviews',
}

const tabOrders = [TAB.JOB_DETAILS, TAB.CANDIDATES, TAB.WORKING_INTERVIEWS];

export const useJobOverview = () => {
  const { postingId, type } = useParams<TJobOverviewPageRoutes>();
  const navigate = useNavigate();
  const state = useSafeLocationState();

  const activeTab = useMemo(
    () => (tabOrders.indexOf(type as TAB) !== -1 ? tabOrders.indexOf(type as TAB) : 0),
    [type],
  );

  const onChangeTab = useCallback(
    (tab: number) => {
      const selectedTab = tabOrders[tab] ?? TAB.JOB_DETAILS;
      navigate(`/permanent-jobs/job-overview/${postingId}/${selectedTab}`, {
        replace: true,
        state,
      });
    },
    [navigate, postingId, state],
  );

  return {
    activeTab,
    onChangeTab,
  };
};
